export default __webpack_public_path__ + "static/media/0330.11a671b0.jpg";